import { render, staticRenderFns } from "./ListBots.vue?vue&type=template&id=5cfd9db6&lang=pug"
import script from "./ListBots.vue?vue&type=script&lang=js"
export * from "./ListBots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cfd9db6')) {
      api.createRecord('5cfd9db6', component.options)
    } else {
      api.reload('5cfd9db6', component.options)
    }
    module.hot.accept("./ListBots.vue?vue&type=template&id=5cfd9db6&lang=pug", function () {
      api.rerender('5cfd9db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/chatbots/ListBots.vue"
export default component.exports